import React, { useEffect } from "react";
import { useNavigate, useRoutes } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core";
import { baseTheme } from "./assets/global/Theme-variable";
import Themeroutes from "./routes/Router";
import AuthRoutes from "./routes/AuthRoutes";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { authAction } from "./Redux/Actions/Auth";
import "./css/formStyle.css";
// Notifier Import
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

const App = () => {
  // Hooks
  const routing = useRoutes(Themeroutes);
  const authRouting = useRoutes(AuthRoutes);
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state.Authentication);
  const dispatch = useDispatch();
  // theam
  const theme = baseTheme;

  const user = localStorage.getItem("user_token");
  const expiration = localStorage.getItem("expiration");
  useEffect(() => {
    // Log the environment variables when the component is mounted
    console.log("API URL:", process.env.REACT_APP_API_URL);
    console.log("Environment:", process.env.REACT_APP_ENV);
    if (user) {
      if (new Date(expiration.toString()) > new Date()) {
        dispatch(authAction(true));
        // navigate("/home");
      } else {
        localStorage.removeItem("user_token");
        localStorage.removeItem("expiration");
        localStorage.clear();
        dispatch(authAction(false));
        navigate("/login");
      }
    } else {
      dispatch(authAction(false));
      navigate("/login");
    }
  }, [user]);

  useEffect(() => {
    if (user && isAuthenticated) {
      // navigate("/home");
    } else {
      navigate("/login");
      dispatch(authAction(false));
    }
  }, [isAuthenticated]);

  return (
    <>
      {/* <ToastContainer
    position="top-right"
    autoClose={5000}
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
  /> */}
      <ThemeProvider theme={theme}>
        {isAuthenticated ? routing : authRouting}
      </ThemeProvider>
    </>
  );
};

export default App;
